import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgCloseRed = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      transform="translate(1 1)"
      stroke="#EC3535"
      strokeWidth={1.5}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle fill="#FFF" cx={8.5} cy={8.5} r={8.5} />
      <path d="m6 6 5 5M11 6l-5 5" />
    </g>
  </svg>
);
const Memo = memo(SvgCloseRed);
export default Memo;
